import moment from 'moment';
export const  AXIS_DEFAULT_COLOR = "white";

/** @ngInject */
export class ChartUtil {
    static getBalanceHistChartDays(translate) {
       return [{label: 10 + ' ' + translate.instant('DAYS'), value: 10, disabled: false},
            { label: 1 + ' ' + translate.instant('MONTH'), value: 30, disabled: false},
            { label: 3 + ' ' + translate.instant('MONTHS'), value: 90, disabled: false}/*,
             { label: 6 + ' ' + translate.instant('MONTHS'), value: 180},
             { label: 1 + ' ' + translate.instant('YEAR'), value: 365}*/];
    }

    static getGrid(color, markings) {
        return {hoverable: true, borderWidth: 1, color: color ? color : AXIS_DEFAULT_COLOR, markings: markings || []};
    }

    static getXAxis(color) {
        return {
            mode: 'time',
            timeformat: "%d",
            font: { color: color ? color : AXIS_DEFAULT_COLOR },
            tickSize: [1, "day"],
            tickLength: 0, // hide gridlines
            autoscaleMargin: 0
         };
    }

    static getYAxis(filterFormatter, color) {
        return {
            show: true,
            font: { color: color ? color : AXIS_DEFAULT_COLOR },
            autoscaleMargin: 0.1,
            tickFormatter: (v) => {
                return "<span class='axisLabel'>" + filterFormatter('fsNumber')(v, 0)  + "</span>";
            }
        };
    }

    static getDetailYAxis(color) {
        return {
            show: true,
            font: { color: color ? color : AXIS_DEFAULT_COLOR },
            autoscaleMargin: 0.1
        };
    }


    static getBarChartOptions(filterFormatter) {

      return  {
            series: {
                bars: {
                    show: true,
                        fill: true,
                        barWidth: 80000000, // a bit less 1 day in seconds
                        align: "center",
                        fillColor: { colors: [{ opacity: 1.0 }, { opacity: 1.0}] }
                },
                shadowSize: 3,
            },
            colors: ['#b7c9e8', '#FDE7E7', '#F8A1A1'],
            xaxis: ChartUtil.getXAxis(),
            yaxis: ChartUtil.getYAxis(filterFormatter),
            grid: ChartUtil.getGrid()
        };
    }

    static getBalanceMonthTitle(selDays, locale, selectedDate = moment()) {

        let month = new Date(selectedDate).toLocaleString(locale, {month: "long"}) +
            ' (' + new Date(selectedDate).toLocaleString(locale, {year: "numeric"}) + ')';
        // moment
        const startDate = moment(selectedDate);
        startDate.subtract(selDays, 'days');
        if(startDate.format('M') !== selectedDate.format('M')) {
            month = new Date(startDate).toLocaleString(locale, {month: "long"}) +
                ' (' + new Date(startDate).toLocaleString(locale, {year: "numeric"}) + ')' +
                ' - ' + month;
        }

        return month;
    }

    static getValSeriesMonthTitle(locale, startDate, endDate) {

        let month = startDate.toLocaleString(locale, {month: "long"}) +
            ' (' + startDate.toLocaleString(locale, {year: "numeric"}) + ')';

        if((endDate.getMonth() !== startDate.getMonth()) || (endDate.getYear() !== startDate.getYear())) {
            month = month + ' - ' + endDate.toLocaleString(locale, {month: "long"}) +
                ' (' + endDate.toLocaleString(locale, {year: "numeric"}) + ')';
        }

        return month;
    }

    static getBarChartDetailOptions(color, width, colors, markings ) {

        return  {
            series: {
                bars: {
                    show: true,
                    fill: true,
                    barWidth: width ? width : 80000000, // a bit less 1 day in seconds
                    align: "center",
                    fillColor: { colors: [{ opacity: 1.0 }, { opacity: 1.0}] }
                },
                shadowSize: 3,
            },
            colors: colors ? colors : ['#b7c9e8', '#FDE7E7'],
            xaxis: ChartUtil.getXAxis(color),
            yaxis: ChartUtil.getDetailYAxis(color),
            grid: ChartUtil.getGrid(color, markings)
        };
    }

    static getLineChartDetailOptions(xaxisColor, colors, markings) {
        return {
            xaxis: {
                mode: 'time',
                timeformat: '%d',
                font: { color: xaxisColor ? xaxisColor : AXIS_DEFAULT_COLOR },
                tickSize:  [1, "day"],
                minTickSize: 2,
                tickLength: 0, // hide gridlines
                autoscaleMargin: 0
            },
            yaxis: ChartUtil.getDetailYAxis(xaxisColor),
            grid: ChartUtil.getGrid(xaxisColor, markings),
            points: {
                show: true
            },
            colors: colors ? colors : ['#056ED5','#b7c9e8', '#F8A1A1'],
            lines: {show: true},
            legend: { show: true,
                noColumns: 0,
                container:'#legendContainerCurr',
                labelFormatter: function labelFormatter(label) {
                    return '<div>' + label + '</div>';
                }
            }
        };
    }

    static formatAxisDisplayWithLimit(selDay, chartOptions, defaultTicksize, defaultTimeFormat, limit) {
        if(selDay >= limit) {
            defaultTicksize = [0, "month"];
            defaultTimeFormat = "%b";
         }

         chartOptions.xaxis.tickSize = defaultTicksize;
         chartOptions.xaxis.timeformat = defaultTimeFormat;
         chartOptions.xaxis.monthNames = moment.months();
    }

    static formatAxisDisplay(selDay, chartOptions, defaultTicksize, defaultTimeFormat) {
        ChartUtil.formatAxisDisplayWithLimit(selDay, chartOptions, defaultTicksize, defaultTimeFormat, 30);
    }
}
